<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.records.records' | appTranslate }}"
        [menuService]="payrollModuleMenuService"
    ></app-header>

    <app-table [table]="table">
        <div class="empty">
            <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
            <h2 class="ui centered header">{{ 'payroll.roes.noRoesFound' | appTranslate }}</h2>
        </div>
    </app-table>
</div>
